<template>
  <div class=" pa-2 rounded elevation-0 bordered bg-grey_3">
    <div class="text-h6">Information de commande</div>
    <div class="d-flex sm-gap mb-2">

      <v-chip variant="elevated" density="compact" color="green-darken-4" prepend-icon="mdi-check"
        v-if="commande.statut == 'PAID' && commande.cycle == 'CLOSED'"> Payée</v-chip>
      <v-chip variant="elevated" density="compact" color="red-darken-4" prepend-icon="mdi-cancel" v-else> Non
        payée</v-chip>
      <v-chip variant="elevated" density="compact" color="primary-dark" prepend-icon="mdi-account-cog"
        v-if="commande.add_by_admin == '1'"> Commande Admin</v-chip>
      <v-chip variant="elevated" density="compact" color="primary-dark" prepend-icon="mdi-account-star"
        v-if="item.lien_privilegie && item.lien_privilegie != ''"> Lien privilégié</v-chip>
    </div>

    <div class="d-flex justify-space-between gap" v-if="item.lien_privilegie && item.lien_privilegie != ''">
      <div>Lien privilégié</div>
      <div class="font-weight-bold">{{ item.lien_privilegie }}</div>
    </div>
    <div class="d-flex justify-space-between gap">
      <div>N° de commande</div>
      <div class="font-weight-bold">{{ commande.uuid }}</div>
    </div>
    <div class="d-flex justify-space-between gap">
      <div>Date</div>
      <div class="font-weight-bold">{{ $moment(commande.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
    </div>
    <div class="d-flex justify-space-between gap">
      <div>Nombre d'articles</div>
      <div class="font-weight-bold">{{ commande.nb_articles }}</div>
    </div>
    <div class="d-flex justify-space-between gap">
      <div>Montant total</div>
      <div class="font-weight-bold" v-if="mainStore.authAdmin.isSportipsAdmin">{{ commande.prix_total }}€ (dont
        taxe: {{ commande.taxe }}€)</div>
      <div class="font-weight-bold" v-else>{{ commande_prix_minus_gia }}€</div>
    </div>
    <div class="d-flex justify-space-between gap">
      <div>Email</div>
      <div class="font-weight-bold">{{ commande.mail }}</div>
    </div>
    <v-divider style="margin: 10px 0 !important"></v-divider>
    <div class="text-h6">Inscriptions liées</div>
    <div v-if="list_inscriptions_coureur.length == 0">Il n'y a pas d'autre inscription associée à cette commande</div>
    <div v-for="other in list_inscriptions_coureur" :key="other.id">
      <div class="d-flex justify-space-between align-center sm-gap bordered mb-1 pa-2 bg-white">
        <div>
          <div class="font-weight-bold">{{ other.nom }} {{ other.prenom }}</div>
          <div class="text-body-2">
            <span v-if="other.course && other.course.nom">Parcours: {{ other.course.nom }}</span>
            <span v-else>Inscription non sportive</span>
          </div>
        </div>
        <router-link :to="{ name: 'EditInscriptionAdmin', params: { id_inscription: other.id } }">
          <v-btn color="primary-dark" variant="elevated" elevation="0" density="compact">Consulter</v-btn>
        </router-link>
      </div>
    </div>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">

      <v-divider style="margin: 10px 0 !important"></v-divider>
      <div>Liste des transactions</div>
      <div v-for="transaction in commande.list_transactions" :key="transaction.id">
        <div class="d-flex justify-space-between gap">
          <div class="font-weight-bold">{{ transaction.uuid }}</div>
          <div>{{ transaction.prix }}€</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";

export default {
  props: ["item"],
  data() {
    return {
      commande: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
    commande_prix_minus_gia() {
      let prix = parseFloat(this.commande.prix);
      if (!this.commande.list_commandes_inscriptions_coureur) return 0;
      for (let i = 0; i < this.commande.list_commandes_inscriptions_coureur.length; i++) {
        const commande_inscription = this.commande.list_commandes_inscriptions_coureur[i];
        if (commande_inscription.gia && commande_inscription.gia.prix) {
          prix -= parseFloat(commande_inscription.gia.prix);
        }
      }
      prix = prix.toFixed(2);

      return prix;
    },
    list_inscriptions_coureur() {
      let list = [];
      if (!this.commande.list_commandes_inscriptions_coureur) return list;
      for (let i = 0; i < this.commande.list_commandes_inscriptions_coureur.length; i++) {
        let commande_inscription = this.commande.list_commandes_inscriptions_coureur[i];
        for (let j = 0; j < commande_inscription.inscriptions.length; j++) {
          let inscription = commande_inscription.inscriptions[j];
          if (inscription.id == this.item.id) {
            continue;
          }
          list.push(inscription);
        }
      }
      return list;
    },
  },
  async created() {
    let req = await AdminService.getCommandeById(this.item.id_commande);
    if (req) {
      this.commande = req;
    }
  },
};
</script>

<style lang="scss" scoped></style>